import axios from 'axios'
import {Response} from '@/domain/Common'
import env from '@/util/Env'

export class Program {
  public static async getEstimationMile(initialAmount: number, tsumitateAmount: number)
    : Promise<EstimationMile> {
    return axios
      .get<Response<EstimationMileRes>>(
        `${env.ApiUrl}/public/mileEstimation`,
        {
          params: {
            initialAmount,
            tsumitateAmount,
          },
        },
      )
      .then((res) => {
        const r = res.data.result
        return {
          halfAYear: Number(r.halfAYear),
          oneYear: Number(r.oneYear),
          threeYear: Number(r.threeYear),
        }
      })
  }
}

export interface EstimationMile {
  halfAYear: number,
  oneYear: number,
  threeYear: number,
}

export interface EstimationMileRes {
  halfAYear: string,
  oneYear: string,
  threeYear: string,
}
